<template>
  <div class="flex flex-col items-center content-center justify-center p-5">
    <div class="w-full max-w-screen-md">
      <ExternalNotFound />
    </div>
  </div>
</template>

<script>
import ExternalNotFound from '@/components/ExternalNotFound'

export default {
  name: 'ExternalNotFoundView',

  components: {
    ExternalNotFound
  }
}
</script>
